import { OnChangeParams } from 'baseui/select';
import {
  Attribute,
  deprecatedPrimaryIdTypes,
  supportedAttributeTypes,
  supportedDiscriminatorAttributeTypes,
  supportedPrimaryIdTypes,
} from '@tigergraph/tools-models';
import { AttributeSelect } from '@/components/schemaDesigner/attributeEditorContainer/attributeEditor/AttributeSelect';

export interface AttributeTypeSelectProps {
  attribute: Attribute;
  isPrimaryId: boolean;
  readOnly?: boolean;
  onChange: (attr: Attribute) => void;
}

export default function AttributeTypeSelect({ attribute, isPrimaryId, readOnly, onChange }: AttributeTypeSelectProps) {
  let options = [];

  const attrOptions = supportedAttributeTypes
    .filter((type) => type !== 'STRING COMPRESS')
    .map((type) => ({ id: type, label: type }));

  const primaryIdTypeOptions = supportedPrimaryIdTypes
    .filter((type) => !deprecatedPrimaryIdTypes.includes(type))
    .map((type) => ({
      id: type,
      label: type,
    }));

  const discriminatorTypeOptions = supportedDiscriminatorAttributeTypes.map((type) => ({
    id: type,
    label: type,
  }));

  if (isPrimaryId) {
    options = primaryIdTypeOptions;
  } else if (attribute.isDiscriminator) {
    options = discriminatorTypeOptions;
  } else {
    options = attrOptions;
  }

  const handleChange = ({ value }: OnChangeParams) => {
    if (value.length > 0) {
      const typeName = value[0].id as string;
      const newAttribute = attribute.clone();
      newAttribute.type.name = typeName;
      if (newAttribute.type.name === 'MAP') {
        newAttribute.type.hasKeyTypeName = newAttribute.type.keyTypeName !== '';
      } else {
        newAttribute.type.hasKeyTypeName = false;
        newAttribute.type.keyTypeName = '';
      }
      if (['MAP', 'SET', 'LIST'].includes(newAttribute.type.name)) {
        newAttribute.type.hasValueTypeName = newAttribute.type.valueTypeName !== '';
        newAttribute.type.hasValueTypeTupleName = newAttribute.type.valueTypeTupleName !== '';
      } else {
        newAttribute.type.hasValueTypeName = false;
        newAttribute.type.valueTypeName = '';
      }
      if (['LIST', 'SET', 'MAP', 'UDT'].includes(newAttribute.type.name)) {
        newAttribute.defaultValue = '';
        newAttribute.hasDefaultValue = false;
      }
      onChange(newAttribute);
    }
  };

  return (
    <AttributeSelect
      disabled={readOnly}
      options={options}
      value={[{ id: attribute.type.name, label: attribute.type.name }]}
      onChange={handleChange}
      placeholder="Select type"
    />
  );
}
